import React from "react";
import Product1 from "../assets/images/Product 1.png";
import Product2 from "../assets/images/Product 2.png";
import Product3 from "../assets/images/Product 3.png";
import Product4 from "../assets/images/Product 4.png";

export default function OurProductsSection() {
  const products = [
    {
      id: 1,
      title: "Dog Chew Bar",
      image: Product1,
      bgColor: "#FDB462",
      href: "/products/dogs-chew-bar",
    },
    {
      id: 2,
      title: "Chew Bar Flavours",
      image: Product2,
      bgColor: "#8DD3C7",
      href: "/products/chew-bar-flavours",
    },
    {
      id: 3,
      title: "Dog Nutrition Supplement",
      image: Product3,
      bgColor: "#BEBADA",
      href: "/products/dogs-nutrition-supplement",
    },
    {
      id: 4,
      title: "Puffs Nuggets for Pets",
      image: Product4,
      bgColor: "#FB8072",
      href: "/products/puff-nuggets-for-pets",
    },
  ];

  return (
    <div className="min-vh-100">
      <div className="container py-5">
        {/* Header */}
        <div className="text-center mb-5">
          <h1
            className="display-5 text-muted"
            style={{
              //   fontFamily: "'Brush Script MT', cursive",
              letterSpacing: "2px",
              //   opacity: 0.3,
            }}
          >
            Our
          </h1>
          <h1
            className="fw-bold text-muted"
            style={{
              fontFamily: "'Brush Script MT', cursive",
              marginTop: "clamp(-20px, -8vw, -40px)",
              letterSpacing: "3px",
              fontSize: "clamp(48px, 18vw, 150px)",
              opacity: 0.2,
            }}
          >
            Products
          </h1>
        </div>

        {/* Products Grid */}
        <div className="row g-4">
          {products.map((product) => (
            <div key={product.id} className="col-12 col-sm-6 col-lg-3">
              <div
                className="card border-0 shadow-sm h-100"
                style={{ borderRadius: "20px" }}
              >
                {/* Image Container */}
                <div
                  className="d-flex align-items-center justify-content-center"
                  style={{
                    height: "250px",
                    backgroundColor: "#f8f9fa",
                    borderRadius: "20px 20px 0 0",
                    fontSize: "100px",
                  }}
                >
                  <img src={product.image} alt=""></img>
                </div>

                {/* Card Body */}
                <div className="card-body text-center pb-4">
                  <h5
                    className="card-title fw-semibold mb-4"
                    style={{
                      color: "#333",
                      fontSize: "1.1rem",
                    }}
                  >
                    {product.title}
                  </h5>

                  {/* Buttons */}
                  <div className="d-grid gap-2">
                    <a
                      className="btn text-white fw-semibold py-2"
                      style={{
                        backgroundColor: "#8B7AB8",
                        borderRadius: "25px",
                        border: "none",
                      }}
                      href="/contact-us"
                    >
                      Enquire Now
                    </a>
                    <a
                      className="btn text-white fw-semibold py-2"
                      style={{
                        backgroundColor: "#9D8EC4",
                        borderRadius: "25px",
                        border: "none",
                      }}
                      href={product.href}
                    >
                      Read More
                    </a>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <style>{`
        .card {
          transition: transform 0.3s ease, box-shadow 0.3s ease;
        }
        
        .card:hover {
          transform: translateY(-5px);
          box-shadow: 0 10px 25px rgba(0,0,0,0.15) !important;
        }
        
        .btn:hover {
          opacity: 0.9;
          transform: scale(1.02);
        }
        
        .btn {
          transition: all 0.2s ease;
        }
      `}</style>
    </div>
  );
}
